export default {"src":"/_next/static/media/dobrozem-member.e68d7b0a.svg","height":450,"width":451,"blurWidth":0,"blurHeight":0};